import { Icon } from './Icon';

/**
 * P-075 (S9) · El botón que abre y cierra una fila de tabla dibujada como tarjeta (teléfono). La fila se
 * sigue abriendo al tocarla; esto la hace alcanzable con el teclado y dice si está abierta. Va dentro de
 * la celda `dt-card-main`; la tabla lleva `n3-has-row-toggle`. En escritorio no se dibuja (`screens.css`).
 */
export function RowToggle({ expanded, onToggle, label }: { expanded: boolean; onToggle: () => void; label: string }) {
  return (
    <button
      aria-expanded={expanded}
      aria-label={`${expanded ? 'Ocultar' : 'Ver'} detalles de ${label}`}
      className="n3-row-toggle"
      onClick={(event) => { event.stopPropagation(); onToggle(); }}
      type="button"
    >
      {expanded ? 'Ver menos' : 'Ver detalles'}
      <Icon name={expanded ? 'chevron-up' : 'chevron-down'} size={14} />
    </button>
  );
}
